import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { BaseDatasource } from '@shared/base/base.datasource';
import { TableColumn } from '@shared/interface/table.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig, ModalOption } from '@shared/components/modal/modal.interface';
import { UtilitiesService } from '@services/utilities.service';
import { API } from '@config/constants/api.constant';
import { ActivatedRoute } from '@angular/router';
import { UrlUtilsService } from '@utils/url-utils.service';
import { BaseService } from '@services/base-service.service';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { IDetailProduct, IDetailVariant, IKeyValue, IListVariantDetail, IStockWarehouseInfo, IVariantStockInfo } from '../../Products.interface';
import { SwiperComponent } from 'swiper/angular';
import { SwiperOptions } from 'swiper';
import { BaseResponse } from '@shared/base/base-response';
import { FilterService } from '@services/filter.service';

@Component({
  selector: 'app-variant-information',
  templateUrl: './variant-information.component.html',
  styleUrls: ['./variant-information.component.scss'],
})
export class VariantInformationComponent implements OnInit, OnDestroy {
  @ViewChild('modalInfoStock') modalInfoStock: ModalComponent;
  @ViewChild('swiperVariant', { static: false }) swiperVariant: SwiperComponent;
  @Input() Data: BehaviorSubject<IDetailProduct | undefined>;

  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_PACKAGE;
  tableColumns: TableColumn[];
  modalDetailConfig: ModalConfig;
  modalDetailOption: ModalOption;
  displayedColumns: string[];
  string_filter: string = '';
  variantList: IListVariantDetail[];
  baseDatasourceVariant: BaseDatasource<IListVariantDetail>;
  DetailVariantData: BehaviorSubject<IKeyValue[]> = new BehaviorSubject<IKeyValue[]>([]);

  BrandId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  titleVariant: BehaviorSubject<string> = new BehaviorSubject<string>('');
  urlPreview: BehaviorSubject<string> = new BehaviorSubject<string>('');
  imageList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  // variantStock$: Observable<any>;
  variantStock$: Observable<BaseResponse<IStockWarehouseInfo[]>>;
  variantStockSubject = new BehaviorSubject<IVariantStockInfo>({} as IVariantStockInfo);
  hasWarehouseSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  reFetchCounter = 3; // limit button 'coba lagi'

  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 50,
    navigation: false,
    pagination: { clickable: true },
  };
  @ViewChild('modalDetail') private modalDetail: ModalComponent;
  private unsubscribe: Subscription[] = [];

  constructor(
    private activeRoute: ActivatedRoute,
    private urlParamService: UrlUtilsService,
    private baseService: BaseService,
    private baseTableService: BaseTableService<any>,
    private ref: ChangeDetectorRef,
    public utilities: UtilitiesService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.getBrand();
    this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasourceVariant = response));

    this.setTableData();
    this.queryHandler();
    this.initPageInfo();
  }

  initPageInfo() {
    const dataSubs = this.baseDatasourceVariant.tableSubject.subscribe((resp) => {
      if (resp.length && resp[0].product_id) {
        const _itemHasWarehouse = resp.filter((item) => item.is_have_warehouse);
        this.hasWarehouseSubject.next(_itemHasWarehouse.length === resp.length);
      }

      return (this.variantList = resp);
    });

    this.unsubscribe.push(dataSubs);
  }

  getBrand() {
    this.BrandId.next(this.activeRoute.snapshot.params.id);

    this.modalDetailConfig = {
      showFooter: false,
      showHeader: false,
    };

    this.modalDetailOption = {
      size: 'lg',
    };
  }

  setTableData() {
    this.isLoading.next(false);
    this.tableColumns = [
      { title: 'NAMA VARIANT', key: 'product_name' },
      { title: 'JUMLAH PER BOX', key: 'qty' },
      { title: 'HARGA SATUAN', key: 'price_unit' },
      { title: 'HARGA PER BOX', key: 'price_per_box' },
      { title: 'AVAILABLE STOCK', key: 'available_stock' },
      { title: 'ACTION', key: 'actions' },
    ];

    this.displayedColumns = this.tableColumns.map((head) => head.key);

    if (this.variantList) {
      this.baseDatasourceVariant.tableSubject.next(this.variantList);
    }
  }

  setDetailVariant(data: IDetailVariant) {
    const getTypeVariant = (): string => {
      return data.qty.split(' ')[1];
    };

    this.DetailVariantData.next([
      { key: 'Jumlah per box', value: this.utilities.toStringWithUnitType(data.qty) },
      { key: 'Berat per box', value: this.utilities.toStringWithUnitType(data.weight) },
      { key: 'Harga Satuan', value: this.utilities.toRupiah(data.price_unit, false) + `/${getTypeVariant()}` },
      {
        key: 'Harga Satuan dengan PPN',
        value: this.utilities.toRupiah(data.price_unit_with_ppn) + `/${getTypeVariant()}`,
      },
      { key: 'Harga per box', value: this.utilities.toRupiah(data.price_per_box, false) },
      { key: 'Harga per box dengan PPN', value: this.utilities.toRupiah(data.price_per_box_with_ppn) },
    ]);
  }

  queryHandler() {
    const paramSubs = this.activeRoute.queryParams.subscribe((data) => {
      this.string_filter = data.string_filter;
      const _queryParams = this.urlParamService.sliceQueryParams();
      this.loadDataTable(_queryParams ? _queryParams : '');
    });

    this.unsubscribe.push(paramSubs);
  }

  loadDataTable(params: string) {
    return this.baseTableService.loadDataTable(API.GET_LIST_VARIANT_DETAIL + this.BrandId.value, params);
  }

  handleAction(id: string) {
    const mainData: IListVariantDetail | undefined = this.variantList.find((item) => item.product_id === id);
    if (mainData) {
      this.urlPreview.next(mainData.product_images[0]);
      this.imageList.next(mainData.product_images);
      this.titleVariant.next(mainData.product_name);
      this.setDetailVariant(mainData.detail_variant);
      this.ref.detectChanges();
      this.modalDetail.open().then();
    }
  }

  changePageEvent($event: any) {
    this.filterService.changePageEvent($event, this.string_filter ?? '');
  }

  onSearch(event: string) {
    this.filterService.onSearch(event);
    this.string_filter = '';
  }

  onClickImagePreview($event: string) {
    this.urlPreview.next($event);
  }

  slideNext() {
    this.swiperVariant.swiperRef.slideNext(100, false);
  }

  slidePrev() {
    this.swiperVariant.swiperRef.slidePrev(100, false);
  }

  counter(i: number) {
    return new Array(i);
  }

  handleInfoVariantStock(variant?: IListVariantDetail) {
    const data = {
      id: variant?.product_id,
      name: variant?.product_name,
      list: [],
    } as IVariantStockInfo;

    this.variantStockSubject.next(data);
    this.modalInfoStock.open().then(() => this.variantStockSubject.next(data));
    this.getVariantStock(data.id);
  }

  getVariantStock(productId: string) {
    // get available variant stock gudang
    this.variantStock$ = this.baseService.getData<IStockWarehouseInfo[]>(`${API.GET_PRODUCT_STOCK}${productId}`);
    this.variantStock$.subscribe((resp) => {
      if (resp && resp.success) {
        this.variantStockSubject.value.list = resp.data;
      }

      return resp;
    });
  }

  reFetchAvailableStock() {
    this.variantStockSubject.value.list = [];
    this.reFetchCounter = this.reFetchCounter - 1;
    this.getVariantStock(this.variantStockSubject.value.id);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}

// todo: remove unused methods
